// @flow
import React, { Component, Fragment } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import type { Conversion as ConversionType } from '../types'
import LabeledWrapper from './LabeledWrapper'
import { InputCell } from '../AudienceEdit'
import Form from './Conversion/Form'
import Select from './Conversion/Select'
import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`

const SelectCell = styled.div`
  flex: 100%;
`

const Delimeter = styled.div`
  padding-left: 16px;
  padding-right: 16px;
`

const t = translateFunc(translations.audience_edit.conversion)

type Props = {|
  conversionData: Object,
  conversions: Array<ConversionType>,
  isDisabled: boolean,
  conversionId: ?number,
  conversionIdErrors?: Array<string>,
  onConversionIdChange: (number) => void,
  onConversionsChange: (Array<ConversionType>) => void
|}

type State = {|
  records: Array<ConversionType>
|}

export default class Conversion extends Component<Props, State> {
  render() {
    const { conversionData, conversions, isDisabled, conversionId } = this.props

    return (
      <Fragment>
        <h2>{t('set_conversion')}</h2>

        <LabeledWrapper label={t('label')} errors={this.props.conversionIdErrors}>
          <InputCell>
            <Wrapper>
              <SelectCell>
                <Select
                  conversions={conversions}
                  isDisabled={isDisabled}
                  conversionId={conversionId}
                  onConversionIdChange={(conversionId) => {
                    this.props.onConversionIdChange(conversionId)
                  }}
                />
              </SelectCell>
              <Delimeter>{t('or')}</Delimeter>
              <div>
                <Form
                  isDisabled={isDisabled}
                  createConversionPath={conversionData.createPath}
                  windowOptions={conversionData.windowOptions}
                  onConversionAdd={(conversion) => {
                    this.props.onConversionIdChange(conversion.id)
                    this.props.onConversionsChange([...conversions, conversion])
                  }}
                />
              </div>
            </Wrapper>
          </InputCell>
        </LabeledWrapper>
      </Fragment>
    )
  }
}
